/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Type_Scope_FixedInputs */

const en_task_type_scope_fixed = /** @type {(inputs: Task_Type_Scope_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An activity stays in its case type; copy it to use it in another.`)
};

const pt_br2_task_type_scope_fixed = /** @type {(inputs: Task_Type_Scope_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma atividade não muda de tipo de caso; copie-a para usá-la em outro.`)
};

/**
* | output |
* | --- |
* | "An activity stays in its case type; copy it to use it in another." |
*
* @param {Task_Type_Scope_FixedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_type_scope_fixed = /** @type {((inputs?: Task_Type_Scope_FixedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Type_Scope_FixedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_type_scope_fixed(inputs)
	return pt_br2_task_type_scope_fixed(inputs)
});